import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  rootCheckbox: {
    color: '#65ac1e'
  }
}));